import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';


export default register('carousel-media', {
  onLoad() {
    const $slider = this.container.querySelector('.carousel-media__wrapper');

    new Flickity($slider, {
      autoPlay: false,
      freeScroll: false,
      prevNextButtons: true,
      wrapAround: true,
      arrowShape:
        'M75.8703 1.12651C74.364 -0.375504 71.9218 -0.375504 70.4154 1.12651L24.1297 47.2804C22.6234 48.7824 22.6234 51.2176 24.1297 52.7196L70.4154 98.8735C71.9218 100.376 74.364 100.376 75.8703 98.8735C77.3766 97.3715 77.3766 94.9362 75.8703 93.4342L32.312 50L75.8703 6.56579C77.3766 5.06378 77.3766 2.62853 75.8703 1.12651Z',
    });
    

  },
});
